import BaseAPI from './base'

class PracticeCourseAPI extends BaseAPI {}

export default new PracticeCourseAPI('v1/practice-course', 'PracticeCourse')
